module.exports = __webpack_public_path__ + "img/user.9a2c21ed.png";